// pod-info.component.ts
import { Component, inject, OnInit } from "@angular/core";
import {
  PodInfo,
  PodInfoService,
} from "../../../../core/services/pod-info.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../../core/services/user.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { UserSetting } from "../../../../core/models/userSetting";
import { EditColoumsComponent } from "../../modals/edit-coloums/edit-coloums.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NodeService } from "../../../../core/services/node.service";
import { NodeAction } from "../../../../core/models/node";
import { interval, lastValueFrom, Subscription } from "rxjs";
import { SyncConfigService } from "src/app/core/services/sync-config.service";
import { CreatePodDialogComponent } from "../../modals/create-pod-dialog/create-pod-dialog.component";
import { TerminalComponent } from "src/app/core/header/dialogs/terminal/terminal.component";
import { StorageService } from "src/app/core/services/storage.service";
import { NavigationService } from "src/app/core/services/navigation.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { EnvironmentService } from "src/app/core/services/environment.service";
import { CodeServerFormComponent } from "../../modals/code-server-form/code-server-form.component";
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationDialogComponent } from "src/app/modules/ai-studio/modals/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-pod-info",
  templateUrl: "./pod-info.component.html",
  styleUrls: ["./pod-info.component.scss"],
})
export class PodInfoComponent implements OnInit {
  private storageService = inject(StorageService);
  private sharedService = inject(NavigationService);
  private _deploymentService = inject(DeploymentService);
  pods: PodInfo[] = [];
  filteredPods: PodInfo[] = [];
  selectedPod: PodInfo | undefined;
  depName =
    this.route.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"];
  available: boolean = true;
  displayedEntries: number = 0;
  p = 1; // current pagination index
  podSearchText: string = "";
  toShowFilter: boolean = false;
  loggedInUser: string = this.authenticationService.currentUserValue.username;
  columnInfo: {
    columnsOfComponents: string[];
    coloumToShow: string[];
  };
  tableName: string = "podinfo";
  nodeListColumnToShow: string[] = [];
  isVdiDeployment: boolean = false;
  filterNodes: string = "All";
  filterPhase: string = "All";
  filterNamespace: string = "All";
  filterJob: string = "All";
  nodeList: String[] = [];
  phaseList: string[] = [];
  namespacesList: string[] = [];
  jobList: string[] = [];
  detailsViewOpen: boolean = false;
  podListAutoReloadSub: Subscription;
  phaseSort: boolean = false;
  nameSort: boolean = false;
  namespaceSort: boolean = false;
  nodeSort: boolean = false;
  jobSort: boolean = false;
  createTimeSort: boolean = false;
  ipSort: boolean = false;
  userSort: boolean = false;
  activeSort: string = "none";
  JupyterHubUrl = this._env.envVariables.JupyterHubUrl;
  constructor(
    private podInfoService: PodInfoService,
    private route: ActivatedRoute,
    private router: Router,
    public userServices: UserService,
    public dialog: MatDialog,
    protected authenticationService: AuthenticationService,
    public snackBar: MatSnackBar,
    public nodeService: NodeService,
    private syncConfig: SyncConfigService,
    private _env: EnvironmentService,
    private spinner: NgxSpinnerService
  ) { }
  headNodeIp: any;

  ngOnInit(): void {
    this.columnInfo = {
      columnsOfComponents: [],
      coloumToShow: [],
    };
    this.columnInfo.columnsOfComponents = [
      "Pod Name",
      "Pod IP",
      "Node",
      "User",
      "Namespace",
      "Phase",
      "Create Time",
      "Restart Count",
      "CPU",
      "Memory",
    ];
    this.getColumnSetting();
    this.getPodsByDeployment(this.depName, true);

    this.podListAutoReloadSub = interval(
      this.syncConfig.config.jobs.detailsReqInterval
    ).subscribe((x) => {
      this.getPodsByDeployment(this.depName, false);
    });
    this.getHeadNodeIp();
  }

  async getHeadNodeIp() {
    this.headNodeIp = await lastValueFrom(
      this.storageService.getHeadNodeIp(this.depName)
    );
    // this.checkUrl();
  }

  ngOnDestroy() {
    if (this.podListAutoReloadSub) {
      this.podListAutoReloadSub.unsubscribe();
    }
  }

  getColumnSetting() {
    this.userServices.getColumnSetting(this.loggedInUser).subscribe((res) => {
      if (res) {
        let s = JSON.parse(JSON.stringify(res));
        if (s.data != null) {
          let colInfo: UserSetting = <UserSetting>(
            JSON.parse(JSON.stringify(s.data))
          );
          colInfo.columnSetting.forEach((e) => {
            if (e.tableName == this.tableName) {
              this.nodeListColumnToShow = e.columnInfo.split(",");
              this.columnInfo = {
                ...this.columnInfo,
                coloumToShow: [...this.nodeListColumnToShow],
              };
            }
          });
        } else {
          if (!this.isVdiDeployment) {
            this.nodeListColumnToShow = ["Namespace", "Phase"];
          } else {
            this.nodeListColumnToShow = ["Namespace", "Phase"];
          }
        }
      } else {
        if (!this.isVdiDeployment) {
          this.nodeListColumnToShow = ["Namespace", "Phase"];
        } else {
          this.nodeListColumnToShow = ["Namespace", "Phase"];
        }
      }
    });
  }

  // Fetch pods by depName
  getPodsByDeployment(depName: string, showSpinner: boolean): void {
    try {
      if (showSpinner) {
        this.spinner.show("create-code-server");
      }
      this.podInfoService.getPodsByDeployment(depName, this.loggedInUser).subscribe(
        (data) => {
          this.spinner.hide("create-code-server");
          this.available = true;
          this.pods = <PodInfo[]>JSON.parse(JSON.stringify(data));

          this.pods.forEach((pod) => {
            this.phaseList.push(pod.status);
            this.nodeList.push(pod.node);
            this.namespacesList.push(pod.namespace);
            this.jobList.push(pod.podOwnerName);
          });
          this.nodeList = [...new Set([...this.nodeList])];
          this.phaseList = [...new Set([...this.phaseList])];
          this.namespacesList = [...new Set([...this.namespacesList])];
          this.jobList = [...new Set([...this.jobList])].filter(
            (job) => job != null
          );
          switch (this.activeSort) {
            case 'phase':
              this.sortPhase(false);
              break;
            case 'name':
              this.sortByPodName(false);
              break;
            case 'node':
              this.sortByPodNode(false);
              break;
            case 'namespace':
              this.sortByPodNamespace(false);
              break;
            case 'job':
              this.sortByPodJob(false);
              break;
            case 'createTime':
              this.sortByCreateTime(false);
              break;
            case 'ip':
              this.sortByPodIp(false);
              break;
            case 'user':
              this.sortByPodUser(false);
              break;
          }
        },
        (error) => {
          this.spinner.hide("create-code-server");
          this.available = false;
          console.error("Error fetching pods in depName", error);
        }
      );
      this.checkIfFromJob();
    }
    catch (error) {
      this.spinner.hide("create-code-server");
      console.error("Error fetching pods by deployment:", error);
    }
  }

  paginationEntries(event) {
    this.displayedEntries = event.target.value;
    this.pods = this.pods.slice(0, this.displayedEntries);
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  toggleFilters() {
    this.toShowFilter = !this.toShowFilter;
  }

  applyFilter() {
    this.filteredPods = [...this.pods];
    if (this.podSearchText != "") {
      this.filteredPods = this.filteredPods.filter(
        (nd) =>
          nd.podName.toLowerCase().includes(this.podSearchText.toLowerCase()) ||
          nd.node.toLowerCase().includes(this.podSearchText.toLowerCase())
      );
    }
    if (this.filterJob != "All") {
      if (this.filterJob == "NA") {
        this.filteredPods = this.filteredPods.filter(
          (n) => n.podOwnerName == null
        );
      } else {
        this.filteredPods = this.filteredPods.filter((n) =>
          n?.podOwnerName?.toLowerCase().includes(this.filterJob.toLowerCase())
        );
      }
    }
    if (this.filterNodes != "All") {
      this.filteredPods = this.filteredPods.filter((n) =>
        n.node.toLowerCase().includes(this.filterNodes.toLowerCase())
      );
    }

    if (this.filterNamespace != "All") {
      this.filteredPods = this.filteredPods.filter((n) =>
        n.namespace.toLowerCase().includes(this.filterNamespace.toLowerCase())
      );
    }

    if (this.filterPhase != "All") {
      this.filteredPods = this.filteredPods.filter((n) =>
        n.status.toLowerCase().includes(this.filterPhase.toLowerCase())
      );
    }
    return this.filteredPods;
  }

  onOutletLoaded(component) {
    component.depName = this.depName;
    component.activePodName = this.selectedPod?.podName;
  }

  checkIfFromJob() {
    this.route.params.forEach((params) => {
      if (params["jobName"]) {
        this.filterJob = params["jobName"];
        this.applyFilter();
      }
    });
  }

  editColoum() {
    if (!this.isVdiDeployment) {
      this.columnInfo.columnsOfComponents = [
        "Create Time",
        "Restart Count",
        "CPU",
        "Memory",
      ];
    } else {
      this.columnInfo.columnsOfComponents = [
        "Create Time",
        "Restart Count",
        "CPU",
        "Memory",
      ];
    }
    const editColumnDailog = this.dialog.open(EditColoumsComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: {
        columnsFromComponents: [...this.columnInfo.columnsOfComponents],
        previoslySelectedColumns: [...this.columnInfo.coloumToShow],
      },
    });
    editColumnDailog.afterClosed().subscribe((res) => {
      if (res.status) {
        if (res.data != null && res.data.length >= 0) {
          let columsName = res.data.map((el) => el.name);
          let columsNameString = columsName.join(",");
          this.userServices
            .updateUserColumnSetting(
              this.loggedInUser,
              columsNameString,
              this.tableName
            )
            .subscribe((data) => {
              if (data) {
                let response = JSON.parse(JSON.stringify(data));
                if (response.status == 200) {
                  this.nodeListColumnToShow = columsNameString.split(",");
                  this.columnInfo = {
                    ...this.columnInfo,
                    coloumToShow: [...this.nodeListColumnToShow],
                  };
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                } else if (response.status != 200) {
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
              }
            });
        }
      }
    });
  }

  resetFilter() {
    this.filterNamespace = "All";
    this.filterNodes = "All";
    this.filterPhase = "All";
    this.filterJob = "All";
    this.podSearchText = "";
  }

  openCodeServer() {
    //open dialog componnet which has code server form
    const codeServerForm = this.dialog.open(CodeServerFormComponent, {
      autoFocus: false,
      disableClose: true,
      width: "600px",
      data: {},
    });
    codeServerForm.afterClosed().subscribe((res) => {
      if (res.status) {
        try{
          this.spinner.show("create-code-server");
          this.podInfoService.createCodeServer(res.data, this.depName).subscribe({
            next: (res: any) => {
              //open new tab with url in new tab
              this.spinner.hide("create-code-server");
              window.open(res.access_url, "_blank");
            },
            error: (err) => {
              this.spinner.hide("create-code-server");
              console.error(err);
            },
          });
        }
        catch (error) {
          this.spinner.hide("create-code-server");
          this.snackBar.open("Failed to create code server", "Ok", {
            duration: 5000,
          });
          console.error(error);
        }
      }
    });
  }

  getActiveFiltersCount(): number {
    let count = 0;
    if (this.filterNamespace !== "All") count++;
    if (this.filterNodes !== "All") count++;
    if (this.filterPhase !== "All") count++;
    if (this.filterJob !== "All") count++;
    return count;
  }

  togglePodView(pod) {
    if (!this.detailsViewOpen) {
      this.detailsViewOpen = true;
    }

    this.nodeService.activePod = pod;
    // this.router.navigate([node.vmName, "Details"], { relativeTo: this.route });
    this.nodeService.updateSelectedPod(pod);
    this.toShowFilter = false;
    this.detailsViewOpen = true;
  }

  hidePodDetails() {
    this.detailsViewOpen = false;
  }

  performAction(pod: { action: NodeAction; podInfo: PodInfo }) {
    if (pod.action.value == 11) {
      try{
        this.dialog.open(ConfirmationDialogComponent, {
          data: {
            title: "Delete Pod",
            message: `Are you sure you want to delete pod ${pod.podInfo.podName}? This action cannot be undone.`,
            confirmText: 'Delete',
            cancelText: 'Cancel',
            type: 'danger'
          },
        }).afterClosed().subscribe((confirmed) => {
          if (confirmed) {
            this.spinner.show("create-code-server");
            // 11 for delete
            this.podInfoService
              .deletePod(
                pod.podInfo.podName,
                pod.podInfo.namespace,
                pod.podInfo.deploymentName
              )
              .subscribe({
                next: (res) => {
                  this.spinner.hide("create-code-server");
                  this.snackBar.open(JSON.parse(JSON.stringify(res)).actionMessage, "Ok", {
                    duration: 5000,
                  });
                },
                error: (err) => {
                  this.spinner.hide("create-code-server");
                  this.snackBar.open(JSON.parse(JSON.stringify(err.error)).actionMessage, "Ok", {
                    duration: 5000,
                  });
                  console.error(err);
                },
              });
          }
        });
      }
      catch (error) {
        this.spinner.hide("create-code-server");
      } 
    }
  }

  openCreatePodDialog(): void {
    const dialogRef = this.dialog.open(CreatePodDialogComponent, {
      width: "600px",
      data: {
        headNodeIp: this.headNodeIp.vmIp,
        depName: this.depName
      },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.openTerminalForPod(result.namespace, result.podName);
      }
    });
  }

  async openTerminalForPod(namespace: string, podName: string) {
    this.sharedService.closeOpenedDialogs();
    this.dialog.open(TerminalComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: "custom-terminal-container",
      hasBackdrop: false,
      id: "terminalDialog",
      data: {
        username: "",
        password: "",
        serverAddress: this._deploymentService.getUrlForUtilityService(
          this.depName,
          this.headNodeIp.vmIp,
          "5001",
          4,
          true
        ),
        reqFromPod: true,
        namespace: namespace,
        podName: podName,
        headNodeIp: this.headNodeIp.vmIp,
      },
    });
  }

  sortPhase(toggle: boolean) {
    if (toggle) {
      this.phaseSort = !this.phaseSort;
    }
    this.activeSort = "phase";
    // Define the desired order for pod phases
    const phaseOrder = [
      "Running",
      "Pending",
      "Succeeded",
      "Completed",
      "Failed",
      "Terminated",
      "Deleted",
    ];
    // Sort pods based on phase, Running first, then Completed, then Failed, then Terminated
    this.pods = this.pods.sort((a, b) => {
      const aIndex = phaseOrder.indexOf(a.status);
      const bIndex = phaseOrder.indexOf(b.status);
      // If phase not found, put it at the end
      const aOrder = aIndex === -1 ? phaseOrder.length : aIndex;
      const bOrder = bIndex === -1 ? phaseOrder.length : bIndex;
      // Ascending or descending based on phaseSort
      return this.phaseSort ? aOrder - bOrder : bOrder - aOrder;
    });
  }

  sortByPodName(toggle: boolean) {
    if (toggle) {
      this.nameSort = !this.nameSort;
    }
    this.activeSort = "name";
    this.pods = this.pods.sort((a, b) => {
      const aName = a.podName.toLowerCase();
      const bName = b.podName.toLowerCase();
      if (this.nameSort) {
        return aName < bName ? -1 : aName > bName ? 1 : 0;
      } else {
        return aName > bName ? -1 : aName < bName ? 1 : 0;
      }
    });
  }

  sortByPodNamespace(toggle: boolean) {
    if (toggle) {
      this.namespaceSort = !this.namespaceSort;
    }
    this.activeSort = "namespace";
    this.pods = this.pods.sort((a, b) => {
      const aNamespace = a.namespace.toLowerCase();
      const bNamespace = b.namespace.toLowerCase();
      if (this.namespaceSort) {
        return aNamespace < bNamespace ? -1 : aNamespace > bNamespace ? 1 : 0;
      } else {
        return aNamespace > bNamespace ? -1 : aNamespace < bNamespace ? 1 : 0;
      }
    });
  }

  sortByPodNode(toggle: boolean) {
    if (toggle) {
      this.nodeSort = !this.nodeSort;
    }
    this.activeSort = "node";
    this.pods = this.pods.sort((a, b) => {
      const aNode = a.node.toLowerCase();
      const bNode = b.node.toLowerCase();
      if (this.nodeSort) {
        return aNode < bNode ? -1 : aNode > bNode ? 1 : 0;
      } else {
        return aNode > bNode ? -1 : aNode < bNode ? 1 : 0;
      }
    });
  }

  sortByPodUser(toggle: boolean) {
    if (toggle) {
      this.userSort = !this.userSort;
    }
    this.activeSort = "user";
    this.pods = this.pods.sort((a, b) => {
      const aUser = a.userName.toLowerCase();
      const bUser = b.userName.toLowerCase();
      if (this.userSort) {
        return aUser < bUser ? -1 : aUser > bUser ? 1 : 0;
      } else {
        return aUser > bUser ? -1 : aUser < bUser ? 1 : 0;
      }
    });
  }

  sortByPodJob(toggle: boolean) {
    if (toggle) {
      this.jobSort = !this.jobSort;
    }
    this.activeSort = "job";
    this.pods = this.pods.sort((a, b) => {
      const aJob = a.podOwnerName.toLowerCase();
      const bJob = b.podOwnerName.toLowerCase();
      if (this.jobSort) {
        return aJob < bJob ? -1 : aJob > bJob ? 1 : 0;
      } else {
        return aJob > bJob ? -1 : aJob < bJob ? 1 : 0;
      }
    });
  }

  sortByCreateTime(toggle: boolean) {
    if (toggle) {
      this.createTimeSort = !this.createTimeSort;
    }
    this.activeSort = "createTime";
    this.pods = this.pods.sort((a, b) => {
      const aCreateTime = new Date(a.age).getTime();
      const bCreateTime = new Date(b.age).getTime();
      if (this.createTimeSort) {
        return aCreateTime < bCreateTime ? -1 : aCreateTime > bCreateTime ? 1 : 0;
      } else {
        return aCreateTime > bCreateTime ? -1 : aCreateTime < bCreateTime ? 1 : 0;
      }
    });
  }

  sortByPodIp(toggle: boolean) {
    if (toggle) {
      this.ipSort = !this.ipSort;
    }
    this.activeSort = "ip";
    this.pods = this.pods.sort((a, b) => {
      const aIp = a.podIP.toLowerCase();
      const bIp = b.podIP.toLowerCase();
      if (this.ipSort) {
        return aIp < bIp ? -1 : aIp > bIp ? 1 : 0;
      } else {
        return aIp > bIp ? -1 : aIp < bIp ? 1 : 0;
      }
    });
  }

  checkUrl() {
    fetch(
      "https://" +
      this.headNodeIp.vmIp +
      ":" +
      this._env.envVariables.UtilityAccessPort +
      "/health",
      { mode: "no-cors" }
    )
      .then(() => {
        return;
      })
      .catch((err) => {
        this.snackBar
          .open("Please check pod manager status", "OK", {})
          .afterDismissed()
          .subscribe(() => {
            window.open(
              "https://" +
              this.headNodeIp.vmIp +
              ":" +
              this._env.envVariables.UtilityAccessPort +
              "/health",
              "_blank"
            );
          });
        console.error("User's browser blocked the request:", err);
      });
  }
}
